import { put, call } from "redux-saga/effects";
import { GET_PASSWORDPOLICY_FAILED,GET_PASSWORDPOLICY_COMPLETED,GET_ALLPASSWORDPOLICY_FAILED,GET_ALLPASSWORDPOLICY_COMPLETED,SAVE_PASSWORDPOLICY_FAILED,SAVE_PASSWORDPOLICY_COMPLETED} from "../actions/Passwordpolicy";
import {PasswordpolicyAPI} from '../../utils/api/PasswordpolicyApi';
export function* getpasswordpolicies(request: any) {
 
    try {
    
         const result=yield call(PasswordpolicyAPI.getpasswordpolicy, request.input);
    //     var status = result.data;
     
        yield put({ 
            type: GET_PASSWORDPOLICY_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: GET_PASSWORDPOLICY_FAILED, payload: e.message });
    }
}
export function* getallpasswordpolicies(request: any) {
 
    try {
      
         const result=yield call(PasswordpolicyAPI.getallpasswordpolicy, request.input);
      //   var status = result.data;
     
        yield put({ 
            type: GET_ALLPASSWORDPOLICY_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: GET_ALLPASSWORDPOLICY_FAILED, payload: e.message });
    }
}
export function* savepasswordpolicies(request: any) {
   
    try {
    
         const result=yield call(PasswordpolicyAPI.savepasswordpolicy, request.input);
   //      var status = result.data;
      
        yield put({ 
            type: SAVE_PASSWORDPOLICY_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_PASSWORDPOLICY_FAILED, payload: e.message });
    }
}